<template>
	<div class="company-live" >
		<top title="大会直播"></top>
		<div v-if="hasAuth==true" class="all">
		<div class="video">
			<div class="viewNumber" v-if="liveDetails.show_views">观看人数 : {{viewNum}}人</div>
			<player ref="player" :videoUrl="videoUrl" v-if="JSON.stringify(liveDetails)!='{}'&&liveDetails.only_show_banner==0"></player>
			<img :src="liveDetails.banner" style="width:100%" v-if="liveDetails.only_show_banner==1">
			<div class="lines-buttons" v-if="more_lines" style="text-align:center;margin:10px;">
				<van-button v-for="(item,index) in line_buttons" :key="index" size="small" :style="{'margin-right':index<line_buttons.length-1?'10px':''}" :color="line_index==index?'#d2020d':''" @click="changeLine(item,index)">{{item.rtc_name}}</van-button>
			</div>
			<h3>{{liveDetails.name}}</h3>
		<div class="swiper-img">
			<van-swipe :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="(item,index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
					  <img :src="item.banner_url" alt="">
					</van-swipe-item>
			</van-swipe>
		</div>
		</div>
		<div class="hr-7" ref="line"></div>
		<div class="container">
			<van-tabs v-model="active" animated swipeable color="#901d22" title-inactive-color="#999" title-active-color="#090909">
			  <van-tab  title="日程安排"  v-if="show_detail==true">
			    <schedule  ref="schedule" :meetingSchedule="meetingSchedule" :color="theme_color"></schedule>
			  </van-tab>
			  <van-tab  title="会议介绍" v-else>
				  <introduction :meetingDes="meetingDes"></introduction>
			  </van-tab>
			  <van-tab  title="互动讨论">
			    <discuss ref="discuss" :admin="admin" :websock="websock" :topicList="topicList" :color="theme_color"></discuss>
			  </van-tab>
			  <van-tab  title="切换会场" v-if="is_show_meetingPlace==true">
			   	<meeting-place :scheduleDate="scheduleDate" :meetingSchedule="meetingSchedules" :color="theme_color"></meeting-place>
			  </van-tab>
			  <van-tab  title="会议介绍" v-if="is_show_des&&show_detail==true">
				  <introduction :meetingDes="meetingDes"></introduction>
			  </van-tab>
			</van-tabs>
		</div>
		</div>
		<van-popup v-model="showActivity" position="center" @close="closePop"  :close-on-click-overlay="closeOverlay" >
			<collect-info :fieldArr="fieldArr" :formset="formset" @func="changeInfoStatus" @changeAuth="changeAuth($event)"></collect-info>
		</van-popup>
		<!-- 弹出二维码 -->
		<van-popup
		v-model="is_show_recommend_qrcode"
		closeable
		position="center"
		class="qrcode"
		:style="{ width: '280px',height:'280px'}"
		>
		<img :src="liveDetails.recommend_qrcode_url" alt="">
		</van-popup>
	</div>
</template>
<script>
	import Schedule from '../components/Meeting/Schedule'
	import Discuss from '../components/Meeting/Discuss'
	import MeetingPlace from '../components/Meeting/MeetingPlace'
	import CollectInfo from '../components/Meeting/CollectInfo'
	import Player  from '@/components/Meeting/Player'
	import Introduction from '@/components/Meeting/Introduction'
	import Top from '../components/Top'
	import {MeetingBanner,MeetingsCollectInfo,MeetingsPlace,MeetingsPlaceDetails,SessionsViewsNum,PersoanalUserInfo,Signature,MeetingsSchedule} from '../../../config/interface.js'
	export default{
		components:{
			Schedule,   
			Discuss,
			MeetingPlace,
			Player,
			Introduction,
			CollectInfo,
			Top
		},
		data(){
			return{
				closeOverlay:false,
				time:10*60*1000,
				admin:[],      //超级管理员
				floatWindow:true,    //浮窗
				showActivity:false,  //活动展示
				viewGift:true,       //观看直播得礼物
				active:0,
				viewNum:0,        //观看人数
				liveDetails:{},
				meetingsPlace:[],
				signatureInfo:{},
				userInfo:'',
				meetingSchedule:[],     //会议日程
				videoUrl:'',   //视频url
				fieldArr:[],    //字段
				swiperImg:[],
				is_show_recommend_qrcode:false,				//二维码展示
				is_show_des:false,				//显示会议介绍
				is_show_meetingPlace:false,
				meetingDes:'',
				scheduleDate:[],
				meetingSchedules:[],
				value:0,
				websock:'',
				obj:'',
				room_id:this.$route.query.id,      //房间号
				connectWebSocket:false,     //websocket是否连接
				pingTimer:null,             //定时器
				topicList:[],               //话题列表
				hasAuth:false,
				formset:{},
				theme_color:'',
				show_detail:true,
				more_lines:false,
				line_buttons:[],
				line_index:0,
				timeout_count:0,
				form_id:this.$route.query.form_id,
				company_area_id:this.$route.query.company_area_id
			}
		},
		watch:{
			topicList(newData,old){
				this.isEmpty=newData.length>0?false:true;
			}
		},
        created(){
            if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){
					this.getUserInfo();
                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		methods:{
            //得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo&&this.userInfo.mobile_status==1){
							// let top=this.$refs.line.getBoundingClientRect().top;
							// let bottom=this.$refs.line.getBoundingClientRect().bottom;
							this.id=this.$route.query.id;
							this.meeting_id=this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id;
							this.getActivities();
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                 this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            })
					        })	
                        }
                    }
                })
            },
			//活动
			getActivities(){
				console.log(this.form_id)
				if(this.form_id){
					const url='/webapi/form/'+this.form_id;
					const method='GET';
					let params={
						module_id:this.company_area_id,
						type:'company_area'
					};
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							let data=res.data;
							if(data.fields.length!=0){
								this.fieldArr=data.fields;
								this.showActivity=Boolean(data.fields.length);
								this.formset=data;
							}
							else{
								this.hasAuth=true;
								this.getMeetingsPlaceDetails();
								this.getMeetingsPlace();
								this.getMeetingNumer();
								this.getBanner();
							}
							this.getSignature();
						}
						else{
							if(res.code==501){
								this.hasAuth=false;
								
							}
						}
					})

				}
				else{
					this.hasAuth=true;
					this.getMeetingsPlaceDetails();
					this.getMeetingsPlace();
					this.getMeetingNumer();
					this.getBanner();
					this.getSignature();

				}
			},
			closePop(){
				this.showActivity=false;
			},
			/**
			 * 去注册
			 */
			goRegister(){

				this.$router.push({
					path:'/user/register'
				})
			},
			//会场详情
			getMeetingsPlaceDetails(){
				this.$store.dispatch('isShowLoading',true);
				const url=MeetingsPlaceDetails;
				const method='POST'
				let params={
					session_id:this.id,
                    chapter_id:this.$route.query.chapter_id?this.$route.query.chapter_id:this.$route.query.c_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.liveDetails=data.session;
						this.is_show_recommend_qrcode=this.liveDetails.is_show_recommend_qrcode?true:false;
						this.is_show_des=this.liveDetails.is_show_des;
						if(this.liveDetails.company_areas.length==0){
							this.is_show_meetingPlace=true;
						}
						if(this.liveDetails&&this.liveDetails.des){
							this.meetingDes=this.liveDetails.des;
						}
						else{
							this.meetingDes=this.liveDetails.meeting.des;
						}
						this.meetingSchedule=data.chapters;
						this.admin=data.session.admin;
						if(this.liveDetails&&this.liveDetails.lines&&Object.keys(this.liveDetails.lines).length>1){
							this.more_lines=true;
							this.line_buttons=[];
							let keys=Object.keys(this.liveDetails.lines);
							for(let i= 0;i<keys.length;i++){
								this.line_buttons.push(this.liveDetails.lines[keys[i]])
								if(i==0){
									data.session.play_url_m3u8=this.liveDetails.lines[keys[i]].play_url_m3u8;
								}
							}
							console.log(this.line_buttons)
						}
						document.title=data.session.name;
						if(common.is_weixin()){
							common.wxShare(data.session.name,data.session.share_sub_title,data.session.shareimg);
						}
						if(data.session&&data.session.hidden_details==1){
							this.show_detail=false;
						}
						//子组件加载完成后 向子组件传递数据
						this.$nextTick(()=>{
							this.$refs.player.getLiveInfo(data.session)
						})
					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
			changeLine(item,index){
				if(index!=this.line_index){
					this.liveDetails['play_url_m3u8']=item.play_url_m3u8;
					this.$nextTick(()=>{
						this.$refs.player.getLiveInfo(this.liveDetails);
					})
					this.line_index=index;
				}
			},
			//会议广告位
			getBanner(){
				const url=MeetingBanner;
				const method='POST'
				let params={
					session_id:this.id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
				
				})
			},
			changeInfoStatus(data){
		
				this.showActivity=data;
			},
			//会议会场
			getMeetingsPlace(){
				const url=MeetingsSchedule;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.meetingSchedules=data.sessions;
						this.scheduleDate=Object.keys(this.meetingSchedules);
						this.theme_color=data.meeting.mission_set.color;
				// scheduleList:[],
					}
				})
			},
			//会议观看人数
			getMeetingNumer(){
				const url=SessionsViewsNum;
				let params={
					session_id:this.id};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.viewNum=data.views;
					}
				})
			},
			clickSwiperImg(item){
				window.location.href=item.url;
			},
			changeAuth(data){
				this.hasAuth=data;
				if(data==true){
					this.getMeetingsPlaceDetails();
					this.getMeetingsPlace();
					this.getMeetingNumer();
					this.getBanner();
				}
			},



			//得到签名
			getSignature(){
				if(Object.keys(this.signatureInfo).length==0){
					const url=Signature;
					const method='POST';
					let params={
						scheme:window.location.protocol
					}
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							let data=res.data;
							this.signatureInfo=data;
							if(!this.userInfo){
								this.getUserInfo();
							}else{
								this.initWebSocket();
							}
										
						}
					})
					
				}else{
					if(!this.userInfo){
						this.getUserInfo();
					}
				}


			},
			//初始化weosocket
			initWebSocket(){ 
        		// const wsuri = "ws://ws.talkmed.com/xgzx-pro?platform="+platform+"&timestamp="+timestamp+"&uasid="+uasid+"&signature="+signature+"&nickname="+nickname+"&avatar="+avatar; 
        		const wsuri = this.signatureInfo.ws_url; 
        		
				this.websock = new WebSocket(wsuri);
        		this.websock.onopen =(data)=>{
        			console.log('连接成功')
        		};        
        		this.websock.onmessage = (event)=>{
        			this.websocketonmessage(event);
        		};               
        		this.websock.onerror = ()=>{
					if(this.timeout_count<5){
						this.timeout_count++;
						console.log('连接失败，等待15s尝试重连'+this.timeout_count)
						setTimeout(()=>{
							this.websocketonerror();
						},15000)
					}
        		};       
        		this.websock.onclose =()=>{
        			this.websocketclose();
      			};
      		},
      		//数据发送
      		websocketSendMessage(){
      			let params={
      				"action": "send_to_all_room_member",
					"params": {
					    "raw": {
					      "body": this.content
					    }
					},
					"room_id":this.room_id
      			}
      			this.websock.send(JSON.stringify(params));
      			this.content='';
      			
      		},
		    //连接建立失败重连
	      	websocketonerror(){
	        	this.initWebSocket();
	      	},
	      	//数据接收
	      	websocketonmessage(res){ 
	      		if (res.data == "pong") return;
	        	var data = JSON.parse(res.data);
	        	//连接成功  加入房间
	        	if(data.code==201){
					this.joinRoom();
					this.connectWebSocket=true;
					this.keepSocket();    
				}else if(data.code==200){
					//正常响应
					console.log(data.action);
					let str=data.action;
					let userId=this.userInfo?this.userInfo.ecs_id:0;
					switch(str){
						//接收到群发信息
						case 'send_to_all_room_member':
						let receiveData=data.data.msg_list[0];
						let obj={
							avatar:receiveData.avatar,
							msg:`<i>${receiveData.nickname} :</i> ${receiveData.body}`,
							direction:userId==receiveData.from_id?'right':'left',
						}
						this.topicList.push(obj);
						// this.backBottom();
						break;
						//消息正在审核中
						case 'wait_check_msg':
						common.toast(data.message,1500);
						break;
						
					}
				}else if(data.code == 301 || data.code == 403){
					//被迫下线  签名错误或者验证已过期
					this.getSignature();
			
				}
	      	},
	      	//关闭websocket
	      	websocketClose(){
	      		this.websock.close();
	      	},
	      	//加入房间
	      	joinRoom(){
	      		let nickname=this.userInfo.nickname;
			 	let avatar=this.userInfo.avatar;
	      		let obj={
	      			"type": "room",
	        		"action":"join_room",
	        		"params": {
	        			"nickname":nickname,
	        			"avatar":avatar
	        		},
	        		"room_id":this.room_id
	      		}
	      		this.websock.send(JSON.stringify(obj));
	      	},
		  	//  维持心跳  WebSocket Ping Pong
		    keepSocket(){
			      console.log("ping");
			      if (this.connectWebSocket) {
			    	  this.websock.send("ping");
			      }
			      this.pingTimer = setTimeout(()=> {
			        this.keepSocket();
			      }, 1000 * 30);
		  	},
	      	websocketclose(e){  
	        	console.log('断开连接',e);
			  },
		},
		destroyed(){
		  window.removeEventListener('popstate', this.goBack, false);
		  //退出这个页面  录播url为空
		  this.$store.dispatch('receiveVideoUrl','');
		  //建立连接  才可以关闭
			if(this.connectWebSocket){
				clearTimeout(this.pingTimer);
			    this.websocketClose();
			}
		}
	}
</script>
<style lang="scss">
	.company-live{
		display: flex;
		flex-direction: column;
		height:100%;
		.all{
			display: flex;
    		width: 100%;
    		height: 100%;
    		flex-flow: column;
		}
		.video{
			.viewNumber{
				position: absolute;
				top:0;
				left:0;
				z-index:1000;
				width:100%;
				height:20px;
				line-height: 20px;
				text-align: center;
				font-size:12px;
				color:#fff;
				background:rgba(17,17,17,0.4);
			}
			h3{
				padding:6px 15px;
				font-size:15px;
				color:$color-black;
			}
		}
		.swiper-img{
			width:100%;
			img{
				width:100% !important;
			}
		}
		.container{
				width:100%;
				flex:1;
				display: flex;
				flex-direction: column;
				overflow: auto;
				.van-tab span{
					font-size:15px;
				}
				.van-tabs--line {
					height:100%;
				}
				.van-tabs__content{
					height:calc(100% - 45px);
				}
				.van-tab__pane-wrapper{
					overflow-y: auto;
				}
		}
		.van-popup{
			border-radius: 5px;
		}
		.activity{
				text-align: center;
				padding:25px 20px;
				background:linear-gradient(2deg,rgba(255,250,248,1) 0%,rgba(255,255,255,1) 100%);
				box-shadow:0px 5px 11px 0px rgba(0,0,0,0.14);
				border-radius:11px;
				.van-popup__close-icon--top-right{

					font-size:20px;
					color:#030303;
					top:10px;
					right:10px;
				}
				img{
					width:240px;
					margin:20px 0;
				}
				button{
					margin:0 auto;
					width:165px;
					height:40px;
					border:0px;
					background:linear-gradient(180deg,rgba(255,124,129,1) 0%,rgba(245,42,42,1) 100%);
					box-shadow:0px 5px 11px 0px rgba(0,0,0,0.14);
					border-radius:22px;
					// font-size:16px;
					// color:#fff;
					text-shadow:0px 5px 11px rgba(0,0,0,0.14);
					p{
						display:flex;
						color:#fff;
					}
				}
				>p{
					width:90%;
					margin:25px auto;
					text-align: justify;
				}
		}
		.qrcode{
			img{
				position: absolute;
				top:50%;
				left:50%;
				transform: translate(-50%,-50%);
				width:200px;
				height:200px;

			}
		}
		.meeting_des {
        	width:100%;
			padding:10px;
			box-sizing: border-box;
			img{
				display: block;
				width:100%  !important;
			}
    	} 
		// 领取礼物
		.receiveGifts{
			@include flex(row);
			align-items:center;
			position: fixed;
			right:0px;
			bottom:60px;
			width:82px;
			height:44px;
			background:rgba(244,103,45,1);
			box-shadow:0px 4px 10px 0px rgba(53,19,18,0.27);
			border-radius:100px 0px 0px 100px;
			img{
				width:60px;
				position: absolute;
				left:-12px;

			}
			p{
				margin-left:45px;
				font-size:11px;
				color:#fff;
				text-align: center;
				text-shadow:0px 1px 1px rgba(152,54,10,0.46)

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Company/Live.vue